'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-autowhatever/dist/index.js
// module id = D5+Z
// module chunks = 11